import { vars } from '@croquiscom-pvt/zds/tokens';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

import { Price } from '@common/components';

const itemCardSlideUp = keyframes`
    from {
        opacity: 0;
        transform: translateY(100%);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

export const Container = styled.div`
  position: relative;
  margin: 0 0 8px;
  padding: 17px 16px 16px 16px;
  border-radius: 8px;
  background: ${vars.v3Color.gray50};
  animation: ${itemCardSlideUp} 0.2s ease-in-out;

  &:last-child {
    margin: 0;
  }
`;

export const ItemTitle = styled.div`
  width: calc(100% - 24px);
  display: flex;
  align-items: center;
`;

export const ProductName = styled.h4`
  margin: 0 0 4px;
  line-height: 1.36;
  letter-spacing: -0.3px;
  color: ${vars.v3Color.gray400};
`;

export const OptionName = styled.p`
  word-break: break-all;
  letter-spacing: normal;
  color: ${vars.v3Color.gray900};
`;

export const MinimumCount = styled.p`
  margin: 0 0 0 2px;
  height: 14px;
  font-weight: 400;
  font-size: 12px;
  color: ${vars.v3Color.gray400};
`;

export const Wrap = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: end;
  max-height: 32px;
`;

export const BottomLine = styled.div<{ visible: boolean }>`
  display: ${(props) => (props.visible ? 'flex' : 'none')};
  margin: 10px 0 0 0;
  align-items: center;
  justify-content: space-between;
`;

export const TotalPrice = styled(Price)`
  color: ${vars.v3Color.gray700};
  letter-spacing: 0;
`;

export const BogoBadge = styled.img`
  width: 21px;
  margin-right: 6px;
`;

export const Tag = styled.span`
  margin: 3px 0 0 0;
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
`;

export const ProductInfo = styled.div`
  margin: 2px 0 0 0;
  display: flex;
  justify-content: end;
`;

export const PreSoldOutText = styled.p`
  height: 14px;
  font-size: 12px;
  font-weight: 400;
  color: ${vars.v3Color.red200};
`;

export const Badge = styled.div`
  margin: 0 3px 0 0;
  display: flex;
  align-items: center;
`;

export const DeliveryDate = styled.span<{ isZigzin?: boolean; is_store_zigzin: boolean; isFastShipping: boolean }>`
  font-size: 12px;
  font-weight: 400;
  color: ${vars.v3Color.gray500};
  ${({ isZigzin }) => isZigzin && `color: ${vars.color.purple400}`};
  ${({ isFastShipping }) => isFastShipping && `color: ${vars.color.blueGray400}`};
  ${({ is_store_zigzin }) => is_store_zigzin && `color: ${vars.color.blue400}`};
`;

export const TouchArea = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
  z-index: 999;
  width: 48px;
  height: 48px;
  text-align: right;
  padding: 17px 16px 0 0;
`;
